import React, { useRef } from "react";
import PropTypes from "prop-types";
import { useInViewport } from "react-in-viewport";

import Typography from "../../atoms/Typography/Typography";

import "./TimelineElement.scss";

const TimelineElement = ({ children, layout, icon, iconBackColor, date }) => {
  const myRef = useRef();
  const { inViewport } = useInViewport(
    myRef,
    {},
    { disconnectOnLeave: false },
    {}
  );

  return (
    <div className={layout ? `timelineelement ${layout}` : "timelineelement"}>
      <div
        ref={myRef}
        className={
          inViewport
            ? "timelineelement-content timelineelement-content-move"
            : "timelineelement-content"
        }
      >
        {children}
      </div>
      <span
        className="timelineelement-icon"
        style={{ backgroundColor: iconBackColor }}
      >
        {icon}
      </span>
      <div className="timelineelement-date">
        <Typography>
          <strong>{date}</strong>
        </Typography>
      </div>
    </div>
  );
};

TimelineElement.propTypes = {
  date: PropTypes.string.isRequired,
  icon: PropTypes.element.isRequired,
  iconBackColor: PropTypes.string.isRequired,
  layout: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default TimelineElement;
